/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import { post, get } from 'aws-amplify/api';
import { validateStorageKeys } from './storageUtils';
import { encrypt } from '../helpers/encryption';

const processBody = (body) => {
  // Encrypt entire payload and return as { r: "encryptedString" }
  if (body) {
    return body.hasOwnProperty('body') ? encrypt(body.body) : encrypt(body);
  } else {
    return body;
  }
};

export async function postRequest(apiConstant, path, req = {}) {
  // Validate storage keys before making API call
  const validationResult = validateStorageKeys();
  if (!validationResult.valid) {
    // Clear affected storage based on which storage failed
    if (validationResult.failedStorage === 'local') {
      // If localStorage failed, clear both localStorage and sessionStorage
      localStorage.clear();
      sessionStorage.clear();
    } else if (validationResult.failedStorage === 'session') {
      // If sessionStorage failed, clear only sessionStorage
      sessionStorage.clear();
    }
    // Redirect to base URL after 1 second
    setTimeout(() => {
      window.location.href = window.location.origin + '/';
    }, 1000);
    return Promise.resolve(null);
  }

  // const sessionToken = localStorage.getItem('temp-session'); // Removed - do not send session token in header
  const body = processBody(req);

  const requestOptions = {
    apiName: apiConstant,
    path,
    options: {
      body,
      headers: {
        // 'Session-Token': sessionToken || '', // Removed - do not send session token in header
        'Content-Type': 'application/json',
      },
    },
  };

  const restOperation = post(requestOptions);

  const response = await restOperation.response;
  const result = await response.body.json();
  return result;
}

export async function getRequest(apiConstant, path) {
  // Validate storage keys before making API call
  const validationResult = validateStorageKeys();
  if (!validationResult.valid) {
    // Clear affected storage based on which storage failed
    if (validationResult.failedStorage === 'local') {
      // If localStorage failed, clear both localStorage and sessionStorage
      localStorage.clear();
      sessionStorage.clear();
    } else if (validationResult.failedStorage === 'session') {
      // If sessionStorage failed, clear only sessionStorage
      sessionStorage.clear();
    }
    // Redirect to base URL after 1 second
    setTimeout(() => {
      window.location.href = window.location.origin + '/';
    }, 1000);
    return Promise.resolve(null);
  }

  // const sessionToken = localStorage.getItem('temp-session'); // Removed - do not send session token in header

  const restOperation = get({
    apiName: apiConstant,
    path,
    options: {
      headers: {
        // 'Session-Token': sessionToken || '', // Removed - do not send session token in header
        'Content-Type': 'application/json',
      },
    },
  });

  const response = await restOperation.response;
  return await response.body.json();
}
